// Update the cart total price owned amount in the message while adding product into the cart
document.addEventListener('on:cart:add', (event) => {
  updateCartOwnedAmount(event.detail.cart.total_price);
});
document.addEventListener('on:line-item:change', (event) => {
  updateCartOwnedAmount(event.detail.cart.total_price);
});

function updateCartOwnedAmount(cartTotalPrice) {
  let productOwnedAmountSpan = document.getElementById('product_owned_amount');
  let cartOwnedAmountSpan = document.getElementById('cart_owned_amount');
  if (productOwnedAmountSpan && cartOwnedAmountSpan) {
    let productOwnedAmount = Number(productOwnedAmountSpan.innerText.replace(' €', '').replace(',', '.'));
    let newCartOwnedAmount = Math.floor(Number(cartTotalPrice) / 10000) + productOwnedAmount;
    cartOwnedAmountSpan.innerText = newCartOwnedAmount + ",00 €";
  }
}
